<template>
    <main class="pd-main pb-100">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                <h4 class="text-uppercase">All Chats</h4>
                </div>
            </header>
            <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div class="card" v-else>
                <div class="card-body p-50 text-center" v-if="!all_chats">
                    <div class="pb-10">
                        <i class="ion-chatboxes fs-svg"></i>
                    </div>
                    <div class="mb-10" >
                       <h5> Welcome to Chat Room! </h5>
                        <p class="mb-10">You do not have any active chats. Start a chat with a Listener</p>
                        <router-link to="/listeners" tag="button" class="btn btn-sm btn-primary text-uppercase">
                            Start One
                        </router-link>
                    </div>
                </div>
                <div class="card-body p-0 row no-margin" v-else>
                    <div class="col-md-3 p-0 br-1 br-primary">
                        <h5 class="card-title text-uppercase"><strong>Active Chats</strong></h5>
                        <!-- for bigger screens -->
                        <div class="chat-sm-hidden scroll h-default media-striped media-list media-list-divided media-list-hover">
                            <div class="media-list-body">
                               <div class="bb-1 media align-items-center" v-for="(discussion, i) in all_discussions" :key="i">
                                   
                                   <a class="flexbox align-items-center flex-grow gap-items" href="#" @click="openChat(discussion)">
                                        <img class="avatar" v-if="discussion.listeners[0].avatars[0].secure_url == null" src="../../assets/static/img/avatar.jpg" alt="image" >
                                        <img class="avatar" v-else :src="discussion.listeners[0].avatars[0].secure_url" alt="image" >
                                        <div class="media-body text-truncate">
                                            <h6>{{discussion.listeners[0].Users[0].nickname}}</h6>
                                        </div>
                                    </a>
                               </div>
                            </div>
                        </div>
                        <!-- for mobile -->
                        <div :class="chat_list?'chat-sm-visible':'chat-sm-hidden'" class="chat-md-hidden scroll h-default media-striped media-list media-list-divided media-list-hover">
                            <div class="media-list-body">
                               <div class="bb-1 media align-items-center"  v-for="(discussion, i) in all_discussions" :key="i"> 
                                   <a class="flexbox align-items-center flex-grow gap-items" href="#" @click="openChatMobile(discussion)">
                                        <img class="avatar" v-if="discussion.listeners[0].avatars[0].secure_url == null" src="../../assets/static/img/avatar.jpg" alt="image" >
                                        <img class="avatar" v-else :src="discussion.listeners[0].avatars[0].secure_url" alt="image" >
                                        <div class="media-body text-truncate">
                                            <h6>{{discussion.listeners[0].Users[0].nickname}}</h6>
                                        </div>
                                    </a>
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="chat-sm-hidden col-md-9 p-10" v-if="!open_chat">
                        <div class="card-body p-100 text-center">
                            <div class="pb-10">
                                <i class="ion-chatboxes fs-svg"></i>
                            </div>
                            <div class="mb-10" >
                                <h5> Welcome to Chat Room! </h5>
                                <strong>Click on a listener to view the chat</strong>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-sm-12 col-md-9 p-0">
                        <!-- for bigger screens -->
                        <div class="chat-sm-hidden mb-60" >
                            <header class="flexbox align-items-center p-10 pr-20 bg-lighter bb-1 border-light">
                                <div class="media align-items-center p-0">
                                    <a href="#">
                                        <img class="avatar" v-if="listener_img == ''" src="../../assets/static/img/avatar.jpg" alt="...">
                                        <img class="avatar" v-else :src="listener_img" alt="...">
                                    </a>
                                    <div class="media-body">
                                        <h6><a href="#">{{listener_name}}</a></h6>
                                    </div>
                                </div>

                                <div class="dropdown">
                                    <a class="text-lighter" data-toggle="dropdown" href="#"><i class="ion-android-more-vertical"></i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" href="#" @click="block"><i class="ion-ios-close"></i> Block Listener</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click="endChat"><i class="ion-log-out"></i> End Chat</a>
                                    </div>
                                </div>
                            </header>
                            <!-- chat content  -->
                            <bounce class="m-0 h-default" v-if="loading"></bounce>
                            <div class="flex-grow h-default" v-else>
                                <div v-if="!no_messages"  class="h-default scroll" id="chat">
                                    <div class="media media-chat"
                                    :class="all_messages.usertype == 'seeker' ? 'media-chat-reverse':null">
                                        <div class="media-body">
                                            <p>{{all_messages.text}}</p>
                                        </div>
                                    </div>
                                    <div v-if="responses.length> 0" >
                                        <div class="media media-chat" v-for="(response) in responses" :key="response.id"
                                        :class="response.usertype == 'seeker' ? 'media-chat-reverse':null" >
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="media media-chat" v-for="(response) in all_messages.responses" :key="response.id"
                                        :class="response.usertype == 'seeker' ? 'media-chat-reverse':null" >
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <footer class="publisher" >
                                <input v-model="message" class="publisher-input" placeholder="Write something">
                                <div class="align-self-end gap-items">
                                    <a class="publisher-btn" @click="sendMessage"><i class="ion-ios-paperplane"></i></a>
                                </div>
                            </footer>
                        </div>
                        <!-- for mobile -->
                        <div :class="chat_list?'chat-sm-hidden':'chat-sm-visible'" class="chat-md-hidden mb-60">
                            <header class="flexbox align-items-center p-10 pr-20 bg-lighter bb-1 border-light">
                                <div class="media align-items-center p-0">
                                    <a href="#" @click="goToChatList">
                                        <i class="ion-arrow-left-c"></i>
                                    </a>
                                    <a href="#">
                                        <img class="avatar" v-if="listener_img == ''" src="../../assets/static/img/avatar.jpg" alt="...">
                                        <img class="avatar" v-else :src="listener_img" alt="...">
                                    </a>
                                    <div class="media-body">
                                        <h6><a href="#">{{listener_name}}</a></h6>
                                    </div>
                                </div>
                                <div class="dropdown">
                                    <a class="text-lighter" data-toggle="dropdown" href="#"><i class="ion-android-more-vertical"></i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" href="#" @click="block"><i class="ion-ios-close"></i> Block Listener</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" href="#" @click="endChat"><i class="ion-log-out"></i> End Chat</a>
                                    </div>
                                </div>
                            </header>
                            <!-- chat content  -->
                            <bounce class="m-0 h-default" v-if="loading"></bounce>
                            <div class="flex-grow h-default" v-else>
                                <div v-if="!no_messages" class="h-default scroll" id="chat-mobile">
                                    <div class="media media-chat"
                                    :class="all_messages.usertype == 'seeker' ? 'media-chat-reverse':null">
                                        <div class="media-body">
                                            <p>{{all_messages.text}}</p>
                                        </div>
                                    </div>
                                    <div v-if="responses.length> 0">
                                        <div class="media media-chat" v-for="(response) in responses" :key="response.id"
                                        :class="response.usertype == 'seeker' ? 'media-chat-reverse':null" >
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="media media-chat" v-for="(response) in all_messages.responses" :key="response.id"
                                        :class="response.usertype == 'seeker' ? 'media-chat-reverse':null">
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                            <footer class="publisher" >
                                <input v-model="message" class="publisher-input" placeholder="Write something">
                                <div class="align-self-end gap-items">
                                    <a class="publisher-btn" @click="sendMessage"><i class="ion-ios-paperplane"></i></a>
                                </div>
                            </footer>
                        </div>
                        
                    </div>
                        
                </div>
            </div>

            
            <!-- Modal for end chat -->
            <modal name="end-chat" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                <div class="boxed boxed--border">
                    <header class="no-border">
                    <div class="header-bar flexbox pl-20 justify-content-between">
                        <h5>
                        END CHAT
                        </h5>
                        <span class="close" @click="hideModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                    </div>
                    </header>
                    <div class="card-body">
                    <p>Please drop a rating for this listener between<strong> 0 and 10!</strong></p>
                            <form>
                                <div class="form-group">
                                    <label for="rating">Rate Listener</label>
                                    <input type="number" class="form-control py-10" v-model="rating"  @blur="$v.rating.$touch()"  id="rating">
                                    <div v-if="$v.rating.$dirty">
                                        <div class="custom-error" v-if="!$v.rating.required">*You have to enter a rating.</div>
                                        <div class="custom-error" v-if="!$v.rating.minValue || !$v.rating.maxValue">*You have to enter a value between 0 and 10.</div>
                                    </div>
                                </div>
                                <button class="btn btn-bold btn-sm btn-primary" disabled v-if="load_rating">
                                    <circle-spin class="m-0"></circle-spin>
                                </button>
                                <button class="btn btn-bold btn-sm btn-primary" v-else :disabled="$v.$invalid"  @click="endDiscussion" type="button">End Chat</button>
                            </form>
                        </div>
                    
                </div>
                </div>
            </modal>

            <!-- Modal for Block listener -->
            <modal name="block-user" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-custom py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideBlockModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5>Block Listener</h5>
                        <div class="p-10">
                            <p>Are you sure you want to block this listener? You will no longer be able to chat with this listener.</p>
                            <button class="btn btn-bold btn-primary" disabled v-if="load_blockuser">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-primary" v-else type="button" @click="blockUser">Block</button>
                        </div>
                    </div>
                </div> 
            </modal>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'
import {required, minValue, maxValue} from "vuelidate/lib/validators";
// import io from 'socket.io-client';

export default {
    name: "chatMember",
    mixins: [allMixins],
    data() {
        return {
            mode: "",
            firstLoad: false,
            loading: false,
            load_send: false,
            load_rating: false,
            load_blockuser: false,
            seeker_id: null,
            all_chats: false,
            open_chat: false,
            end: false,
            columns: ["name"],
            all_discussions: [],
            current_discussion_id: null,
            all_messages: {},
            no_messages: true,
            responses: [],
            main_message_id: null,
            message: '',
            listener_name: '',
            listener_img: '',
            listener_id: null,
            listener_user_id : null,
            rating: null,
            chat_list: true,
            // socket : io('https://mcfapi.herokuapp.com')
        }
    },
    validations: {
        rating: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(10),
        }
    },
     watch: {
        all_messages:{
            handler: function() {
            this.$nextTick(function() {
                    var divs = document.getElementById('chat')
                    var div_mobile = document.getElementById('chat-mobile')
                    divs.scrollTop = divs.scrollHeight
                    div_mobile.scrollTop = div_mobile.scrollHeight
            }) },
            deep: true
        },
        responses: {
            handler: function() {
            this.$nextTick(function() {
                    var divs = document.getElementById('chat')
                    var div_mobile = document.getElementById('chat-mobile')
                    divs.scrollTop = divs.scrollHeight
                    div_mobile.scrollTop = div_mobile.scrollHeight
            }) },
            deep: true
        }
    },
    methods: {
        
        goToChatList() {
            this.chat_list = true
        },
        openChatMobile(payload) {
            this.openChat(payload)
            this.chat_list = false
        },
        openChat(payload) {
            this.listener_name = `${payload.listeners[0].Users[0].nickname}`
            this.listener_img = payload.listeners[0].avatars[0].secure_url
            this.listener_user_id = payload.listeners[0].Users[0].id
            this.listener_id = payload.listeners[0].id
            this.current_discussion_id = payload.id
            this.open_chat = true
            this.loading = true
            axios.get(`/users/discussion/one?id=${this.current_discussion_id}&seekerId=${this.seeker_id}`)
            .then(res => {
                this.loading = false
                if(res.data.discussion.messages.length > 0){
                    this.no_messages = false
                    this.all_messages = res.data.discussion.messages[0]
                    this.main_message_id = this.all_messages.id
                }
                else {this.no_messages = true }
                
                // console.log(this.all_messages)
            })
            .catch(err => {
                this.loading = false
                this.$notify({
                    group: 'response',
                    type: 'error',
                    text:  `${err.response.data.message}`,
                    duration: 5000
                })
            })
            
        },
        sendMessage() {
            if(this.no_messages == true) {
                let userData = {
                    discussionId: this.current_discussion_id,
                    text: this.message,
                    senderId: this.seeker_id,
                    usertype: "seeker"
                }
                this.$socket.emit('new_message', {
                    discussionId: this.current_discussion_id,
                    text: this.message,
                    senderId: this.seeker_id,
                    usertype: "seeker"
                }, data => {
                })
                this.message= ''
            }
            else {
                let userData = {
                    messageId: this.main_message_id,
                    text: this.message,
                    senderId: this.seeker_id,
                    usertype: "seeker"
                }
                this.$socket.emit('message_reply', {
                    messageId: this.main_message_id,
                    text: this.message,
                    senderId: this.seeker_id,
                    usertype: "seeker"
                }, data => {
                    // this.all_messages.responses.push(data)
                })
                this.message = ''
            }
        },
        block() {
            this.$modal.show("block-user");
        },
        hideBlockModal(a) {
            a.hide('block-user')
        },
        blockUser() {
            this.load_blockuser = true
                let userData = {
                    userId: this.listener_user_id
                }
                axios.post('/users/block-user', userData)
                .then(res => {
                    let endData = {
                        helpseekerId: this.seeker_id,
                        discussionId: this.current_discussion_id,
                    }
                    axios.post('/users/discussion/end', endData)
                    .then(res => {
                        this.load_blockuser = false
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'User successfully blocked.',
                            duration: 2500,
                        })
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                    })
                    .catch(err => {
                        this.load_blockuser= false
                        this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000,
                        });
                    }) 
                })
                .catch(err => {
                    this.load_blockuser= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text: `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
        },
        endChat() {
            this.$modal.show("end-chat")
        },
        hideModal(a) {
            this.rating = ""
            this.$v.$reset()
            a.hide('end-chat')
        },
        endDiscussion() {
            this.load_rating = true
            let userData = {
            seekerId: this.seeker_id,
            listenerId: this.listener_id,
            score: this.rating
            }
            // console.log(userData)
            axios.post('users/rate-listener', userData)
            .then(res => {
            
                let userData = {
                    discussionId: this.current_discussion_id,
                    helpseekerId: this.seeker_id
                }
                // console.log(userData)
                axios.post('/users/discussion/end', userData)
                .then(res => {
                    this.load_rating = false
                    this.$notify({
                        group: 'response',
                        type: 'success',
                        text: `${res.data.message}`,
                        duration: 2500,
                    })
                    setTimeout(() => {
                        location.reload()
                    }, 3000)
                })
                .catch(err => {
                    this.load_rating= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                }) 
            })
            .catch(err => {
                this.load_rating= false
                this.$notify({
                    group: 'response',
                    type: 'error',
                    text:  `${err.response.data.message}`,
                    duration: 5000,
                });
            })
        }
    },
    mounted() {
        this.firstLoad = true
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
        axios.get(`users/find/${details.id}`)
        .then(res => {
            this.seeker_id= res.data.seeker[0].id
            // TO DO: Get all discussions for the current user, return listeners details with userIDs too

            axios.get(`/users/discussion/all/user/active?m=seeker&seekerId=${this.seeker_id}`)
            .then(res => {
                this.all_discussions= res.data.discussions
                // this.seeker_user_id = res.data.discussions[0].seekers[0].Users[0].id
                if(this.all_discussions.length > 0){
                    this.all_chats = true
                    this.firstLoad = false
                }
                else {
                    this.all_chats = false
                    this.firstLoad = false
                }
            })
            .catch(err => {
                this.firstLoad = false
                // console.log(err)
                this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000
                })
            })
        })
        .catch(err => {
            this.firstLoad = false
                this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000
                })
        })
        
    },
    sockets: {
        message_pop: function(val){
            this.all_messages = val;
            this.main_message_id = val.id
            this.no_messages = false
        },
        response_pop: function(val){
            if(!this.all_messages.responses){
                this.responses.push(val)
            }
            else {
               this.all_messages.responses.push(val);
            }
        }
    }
}
</script>